import { MapPin } from "lucide-react";
import { CLINIC } from "../data/clinic";

export default function Areas() {
  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="lfc-section relative overflow-hidden"
    >
      <div className="absolute inset-y-0 left-0 right-0 bg-gradient-to-r from-[#251047]/30 via-transparent to-[#251047]/30 pointer-events-none" />
      <div className="absolute top-0 right-1/3 w-[420px] h-[420px] rounded-full bg-[#2BB8B4]/10 blur-[110px] pointer-events-none" />

      <div className="lfc-container relative">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <div className="lfc-eyebrow mb-4">Areas we cover</div>
            <h2 className="lfc-h2">
              Mobile foot care across central Scotland.
            </h2>
            <p className="mt-6 text-lg text-[#C2B4E6] leading-relaxed">
              Litisha Foot Care proudly provides home visit appointments throughout
              the regions below. If you're nearby and not sure, please get in touch —
              we may still be able to help.
            </p>
            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={`tel:${CLINIC.phoneRaw}`}
                data-testid="areas-call-cta"
                className="lfc-btn-primary"
              >
                Call to confirm coverage
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
              {CLINIC.areas.map((area, i) => (
                <div
                  key={area}
                  data-testid={`area-${i}`}
                  className="group lfc-card p-6 flex items-center gap-4"
                >
                  <div className="w-11 h-11 rounded-full grid place-items-center bg-[#2BB8B4] text-[#0E0524] shrink-0">
                    <MapPin className="w-5 h-5" strokeWidth={1.8} />
                  </div>
                  <div>
                    <div
                      className="text-[16px] font-semibold leading-tight text-white"
                      style={{ fontFamily: "Outfit" }}
                    >
                      {area}
                    </div>
                    <div className="text-[13px] text-[#8B7FB5] mt-0.5">
                      Home visits available
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
